import { Spinner, Text } from "@/elements"
import { cn } from "@/utils/classnames"
import React, { FC, forwardRef } from "react"

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean
  active?: boolean
  success?: boolean
  LeftElement?: React.FC | null
  RightElement?: React.FC | null
}

export const SquareButton = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { children, loading, active = false, success, LeftElement, RightElement, className, disabled = false, ...rest },
    ref
  ) => {
    return (
      <button
        ref={ref}
        disabled={loading || disabled}
        className={cn(
          "inline-flex items-center justify-center rounded-md bg-bg-2 px-4 py-2 hover:bg-bg-3",
          loading && "cursor-not-allowed",
          className
        )}
        {...rest}>
        <div
          className={`flex w-full flex-nowrap items-center justify-center transition-opacity duration-200 ${loading ? "opacity-0" : "opacity-100"}`}>
          {LeftElement && <LeftElement />}
          <Text className="flex flex-shrink-0" variant="CTASmall">
            {children}
          </Text>
          {RightElement && <RightElement />}
        </div>
        <div
          className={`absolute flex w-full items-center justify-center transition-opacity duration-200 ${loading ? "opacity-100" : "opacity-0"}`}>
          <Spinner size="small" />
        </div>
      </button>
    )
  }
)

SquareButton.displayName = "SquareButton"
